<template>
<div>
  <Alert
    type="alert-info"
    text="Chat is a sequence of actions, for every message from a user one action will be executed.
    Action can contain multiple tasks. task can be a replying to user, sending message to channel/group/user,
    making HTTP request, storing data ... etc."
  ></Alert>
  <AlertLink
    link="/user-guide#Chats"
    text="Read more about Chats and available Tasks here."
  ></AlertLink>

  <div class="input-group mb-3">
    <div class="input-group-prepend">
      <span class="input-group-text">Chat Name</span>
    </div>
    <input type="text" ref="input" class="form-control" @input="changeCurrentChat" :value="current_chat" placeholder="any nice name">
  </div>
</div>
  
</template>


<script>
import Alert from "@/components/Alert.vue";
import AlertLink from "@/components/AlertLink.vue";

export default {
  name:'ChatName',
  components:{
    Alert,
    AlertLink
  },
  props:{
    current_chat: String
  },
  methods: {
    changeCurrentChat: function(event){
      this.$emit('changeCurrentChat',event.target.value);
    }
  },
}
</script>
